import React from "react";
import SiteNavbar from "../components/SiteNavbar.js";
import LandingPage from "../pages/LandingPage.js";
const Site = () => {
  return (
    <div>
      {/* Site Navbar */}
      <SiteNavbar />
    </div>
  );
};

export default Site;
